import { UserDTO } from "../users/user.model";

export class ProductToImportBase {
  public collectionId: number;
  public collectionName: string;
  public shopSellingPeriodFrom: Date;
  public shopSellingPeriodTo: Date;
  public jobDetail?: JobDetailsDto;
  public stylesCount: number;
  public productId: number;
  public productCode: string;
  public extCode: string;
  public productName: string;

  constructor(init?: Partial<ProductToImportBase>) {
    Object.assign(this, init);
  }
}

export class JobDetailsDto {
  id: string;
  jobId: string;
  externalId: string;
  type: string;
  storedId: number;
  startTime: string;
  endTime: string;
  internalId: string;
  error: string;
  wholesaleDiscountPercentage: number;
  requestedByUserId: number;
  constructor(init?: JobDetailsDto) {
    Object.assign(this, init);
  }
}

export class JobDetailsVm extends JobDetailsDto {
  user: UserDTO;
  constructor(init?: JobDetailsVm) {
    super();
    Object.assign(this, init);
  }
}

export class ProductToImportVM extends ProductToImportBase {
  public checked?: boolean;
  public disabled?: boolean;
  public importedStatus: ImportedStatusEnum;
  public wholesaleDiscountPercentage: number;

  constructor(init?: Partial<ProductToImportVM>) {
    super();
    Object.assign(this, init);
  }
}

export class jobImport {
  wholesalePercentageDiscount: number;
  importProductJobs: ImportProductJob[];
  constructor(init?: jobImport) {
    Object.assign(this, init);
  }
}

export class ImportProductJob {
  externalId: string;
  storeId: number;
  constructor(init?: ImportProductJob) {
    Object.assign(this, init);
  }
}

export enum ImportedStatusEnum {
  notImported = 1,
  imported = 2,
  importing = 3,
  failed = 4
}
